import Experience from "../Experience"

export default class Html {
    constructor() {
        this.experience = new Experience()
        this.scene = this.experience.scene
        this.ressources = this.experience.ressources
        this.time = this.experience.time
        this.router = this.experience.router

        this.textes = [
            {
                name: 'chapitre1', data: ['Voilà plusieurs décennies que, jour après jour, la machine à idées régurgite inlassablement ses décoctions insipides pour contenter les âmes, qui viennent la téter religieusement. ', 'Jadis, une âme s’en souvient, les idées rouges abondaient. Elles s’échangeaient, s’influençaient, mais jamais leur couleur ne ternissait.']
            },
            { name: 'chapitre2', data: ['2.1', '2.2'] },
            { name: 'chapitre3', data: ['3.1', '3.2'] },
            { name: 'chapitre4', data: ['4.1', '4.2'] },
            { name: 'chapitre5', data: ['5.1', '5.2'] },
            { name: 'chapitre6', data: ['6.1', '6.2'] },
        ]

        this.currentIndex = 0
        this.setTextContainer()
        this.setMenu()


        this.updateTextFromRoute()


    }

    updateTextFromRoute(goToLastText = false) {
        const chapterName = this.router.path.replace('/', '')
        const chapterIndex = this.textes.findIndex(e => e.name === chapterName)

        if (chapterIndex !== -1) {
            this.currentChapterIndex = chapterIndex
            this.currentTextData = this.textes[chapterIndex].data

            this.currentIndex = goToLastText
                ? this.currentTextData.length - 1
                : 0

            this.fadeText(this.currentTextData[this.currentIndex])
            this.testButtonsVisibility()
        }
    }


    animateTransform(element, from, to, delay = '0s', transition = 'transform 0.3s ease-in-out') {
        element.style.transition = 'none'
        element.style.transform = from
        void element.offsetHeight
        element.style.transition = transition
        element.style.transitionDelay = delay
        element.style.transform = to
    }

    setMenu() {
        const menu = document.querySelector('.menu')
        const closeButton = document.querySelector('.menu .close')
        const openButton = document.querySelector('.menu .open')
        const logoText = document.querySelector('.menu .logo .logoText')
        const logoImg = document.querySelector('.menu .logo img')
        const stroke = document.querySelector('.menu .linksContainer .stroke')
        const chapitresLinks = document.querySelectorAll('.menu .linksContainer ul.left li a')
        const otherLinks = document.querySelectorAll('.menu .linksContainer ul.right li a')
        const arrowLeft = document.querySelector('.textContainer .blur .arrowLeft')
        const arrowRight = document.querySelector('.textContainer .blur .arrowRight')
        setTimeout(() => {
            this.animateTransform(openButton, 'translate(0%, -100%)', 'translate(0%, 0%)', '0.25s')

        }, 1000)

        const menuButtonDelay = '1s'

        const openMenu = () => {
            this.animateTransform(openButton, 'translate(0%, 0%)', 'translate(0%, -100%)')
            this.animateTransform(closeButton, 'translate(0%, 100%)', 'translate(0%, 0%)', menuButtonDelay)
            this.animateTransform(logoText, 'translate(0%, 100%)', 'translate(0%, 0%)', '0.25s')
            this.animateTransform(arrowLeft, 'translate(0%, 0%) rotate(-45deg)', 'translate(-200%, 0%) rotate(-45deg)', '0s')
            this.animateTransform(arrowRight, 'translate(0%, 0%) rotate(45deg)', 'translate(200%, 0%) rotate(45deg)', '0s')
            menu.style.transitionDelay = '0s'
            menu.style.backgroundColor = 'var(--primary)'
            logoImg.style.opacity = '1'
            stroke.style.left = '50rem'
            stroke.style.right = ''
            stroke.style.width = '800rem'


            chapitresLinks.forEach((link, i) => {
                this.animateTransform(link, 'translate(0%, -100%)', 'translate(0%, 0%)', `${0.25 + i * 0.1}s`)
                link.classList.toggle('show-before', this.router.path === link.pathname)
            })

            otherLinks.forEach((link, i) => {
                this.animateTransform(link, 'translate(0%, -100%)', 'translate(0%, 0%)', `${0.25 + i * 0.1}s`)
                link.classList.toggle('show-before', this.router.path === link.pathname)
            })

            this.textContainer.querySelector('.topBorder').style.borderRadius = '0rem'
            this.textContainer.querySelector('.bottomBorder').style.borderRadius = '0rem'
        }

        const closeMenu = () => {
            this.animateTransform(openButton, 'translate(0%, 100%)', 'translate(0%, 0%)', menuButtonDelay)
            this.animateTransform(closeButton, 'translate(0%, 0%)', 'translate(0%, -100%)')
            this.animateTransform(logoText, 'translate(0%, 0%)', 'translate(0%, 100%)')
            this.animateTransform(arrowLeft, 'translate(250%, 0%) rotate(-45deg)', 'translate(0%, 0%) rotate(-45deg)', '0.8s')
            this.animateTransform(arrowRight, 'translate(-250%, 0%) rotate(45deg)', 'translate(0%, 0%) rotate(45deg)', '0.8s')

            menu.style.transitionDelay = '0.5s'
            menu.style.backgroundColor = 'var(--transparent)'
            logoImg.style.opacity = '0'
            stroke.style.right = '50rem'
            stroke.style.left = ''
            stroke.style.width = '0rem'


            chapitresLinks.forEach((link, i) => {
                this.animateTransform(link, 'translate(0%, 0%)', 'translate(0%, 100%)', `${i * 0.03}s`)
            })
            otherLinks.forEach((link, i) => {
                this.animateTransform(link, 'translate(0%, 0%)', 'translate(0%, 100%)', `${i * 0.03}s`)
            })

            this.textContainer.querySelector('.topBorder').style.borderRadius = '25rem'
            this.textContainer.querySelector('.bottomBorder').style.borderRadius = '25rem'
        }
        const handleLinkClick = (e) => {
            e.preventDefault()

            const clickedPath = e.currentTarget.pathname
            const currentPath = this.router.path

            if (clickedPath === currentPath) return
            this.router.route(e);
            this.updateTextFromRoute();
            closeMenu()

        }


        openButton.addEventListener('click', openMenu)
        closeButton.addEventListener('click', closeMenu)

        chapitresLinks.forEach(link => {
            link.addEventListener('click', handleLinkClick)
        })
        otherLinks.forEach(link => {
            link.addEventListener('click', handleLinkClick)
        })
    }

    setTextContainer() {
        this.textContainer = document.querySelector('.textContainer')
        setTimeout(() => {
            this.textContainer.style.opacity = '1'
            this.textContainer.style.bottom = '130rem'
            this.textContainer.querySelector('.blur').style.backdropFilter = 'blur(10px)'


        }, 1400)


        this.links = this.textContainer.querySelectorAll('.blur a')

        this.leftButton = this.links[0]
        this.rightButton = this.links[1]

        this.isLocked = false

        const lockButtons = () => {
            this.isLocked = true
            setTimeout(() => {
                this.isLocked = false
            }, 1000)
        }

        this.testButtonsVisibility()

        this.leftButton.addEventListener('click', (e) => {
            e.preventDefault()
            if (this.isLocked) return
            this.animateTransform(this.leftButton.children[0], 'translate(0%, 0%) rotate(-45deg)', 'translate(-200%, 0%) rotate(-45deg)', '0s')


            setTimeout(() => {
                this.animateTransform(this.leftButton.children[0], 'translate(200%, 0%) rotate(-45deg)', 'translate(0%, 0%) rotate(-45deg)', '0s')
            }, 500)
            this.handleArrowClick(e)
            lockButtons()
        })

        this.rightButton.addEventListener('click', (e) => {
            e.preventDefault()
            if (this.isLocked) return
            this.animateTransform(this.rightButton.children[0], 'translate(0%, 0%) rotate(45deg)', 'translate(200%, 0%) rotate(45deg)', '0s')
            setTimeout(() => {
                this.animateTransform(this.rightButton.children[0], 'translate(-200%, 0%) rotate(45deg)', 'translate(0%, 0%) rotate(45deg)', '0s')
            }, 500)
            this.handleArrowClick(e)
            lockButtons()
        })
    }

    testButtonsVisibility() {
        const isFirst = (this.currentChapterIndex === 0 && this.currentIndex === 0)
        this.leftButton.style.opacity = isFirst ? '0' : '1'
        this.leftButton.style.pointerEvents = isFirst ? 'none' : 'auto'

        const isLast = (
            this.currentChapterIndex === this.textes.length - 1 &&
            this.currentIndex === this.currentTextData.length - 1
        )

        this.rightButton.style.opacity = isLast ? '0' : '1'
        this.rightButton.style.pointerEvents = isLast ? 'none' : 'auto'

    }

    handleArrowClick(event) {
        const isRight = event.currentTarget.children[0]?.classList.contains('arrowRight')

        if (isRight) {
            this.currentIndex++
        } else {
            this.currentIndex--
        }

        this.testButtonsVisibility()

        if (this.currentIndex >= this.currentTextData.length) {
            if (this.currentChapterIndex < this.textes.length - 1) {
                this.currentChapterIndex++
                this.currentIndex = 0
                this.changeChapter(event.currentTarget, event)
            } else {
                this.currentIndex = this.currentTextData.length - 1
            }
            return
        }


        if (this.currentIndex < 0) {
            this.currentChapterIndex--
            this.currentIndex = 0
            this.changeChapter(event.currentTarget, event)
            return
        }

        this.fadeText(this.currentTextData[this.currentIndex])
    }

    changeChapter(link, event) {
        link.setAttribute('href', `/chapitre${this.currentChapterIndex + 1}`)
        this.router.route(event)
        const chapterNumber = parseInt(link.getAttribute('href').replace('/chapitre', ''))
        const prevChapterNumber = this.router.prevRoute.replace('/chapitre', '')
        const isGoingBackward = chapterNumber < prevChapterNumber
        this.updateTextFromRoute(isGoingBackward)
    }

    fadeText(text) {
        const textElement = this.textContainer.querySelector('.blur .text')
        textElement.style.opacity = '0'
        setTimeout(() => {
            textElement.innerHTML = text || ''
            textElement.style.opacity = '1'
        }, 500)
    }
}

